import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Controller, useForm } from "react-hook-form";
import { useEffect, useRef, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVCheckbox } from "../../shared/JVCheckbox";
import { JVDate } from "../../shared/JVDate";
import { JVInput } from "../../shared/JVInput";
import { JVSunEditor } from "../../shared/JVSuneditor";
import { RadioButton } from "primereact/radiobutton";
import { JVRadioBtn } from "../../shared/JVRadioBtn";
import { format } from "date-fns";
import { InputTextarea } from "primereact/inputtextarea";

interface IProps {
    singleData: any,
    open: boolean,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void
    //loadTableData: () => void,
    HidePenFollowup: () => void,

}


const schema = yup.object({
});
interface ISubNum {
    //max_Submission: number
}
let EmptyRequirement: ISubNum = {
    // max_Submission: 0
};

export const Form = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<any>, loading: boolean });
    const [loading, setLoading] = useState(false);
    const [openMailBody, setOpenMailBody] = useState({ contact_Person_EmailID: "", open: false } as { contact_Person_EmailID: string, open: boolean })
    const [mailBody, setMailBody] = useState("");
    const [mailTo, setMailTo] = useState(""); // store the email of the contact person
    const [mailHistory, setMailHistory] = useState({ followup_ID: 0, open: false } as { followup_ID: number, open: boolean })
    const [historyData, setHistoryData] = useState({ tableData: [], loading: false } as { tableData: Array<any>, loading: boolean });
    const [comment, setComment] = useState<string>('');

    const { control, handleSubmit, watch, formState: { errors }, reset, setValue } = useForm<any>({
        resolver: yupResolver(schema),
        defaultValues: EmptyRequirement,
        shouldFocusError: false
    });


    const isFollowupOnPhone = watch("isFollowupOnPhone");
    const isFollowupMail = watch("isFollowupMail");
    const isFollowUpCallRespond = watch("isFollowUpCallRespond");
    const isFollowUpMailRespond = watch("isFollowUpMailRespond")

    const dt = useRef<any>(null);


    const saveToDB = async (data: any) => {
        setLoading(true);
        const body = {
            followup_ID: tableData.tableData[0].followup_ID,
            isFollowupMail: data.isFollowupMail,
            isFollowupOnPhone: data.isFollowupOnPhone,
            isFollowupDone: data.isFollowupDone,
            next_Followup_Date: data.next_Followup_Date,
            isFollowUpCallRespond: data.isFollowUpCallRespond,
            followUpCallRemark: data.followUpCallRemark,
            isFollowUpMailRespond: data.isFollowUpMailRespond,
            followUpMailRemark: data.followUpMailRemark,
            comment: data.comment

        };
        const response = await Fetch("InActivePrimeVendor/updateFollowUp", "POST", body, null, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', detail: "Updated Successfully", life: 3000 });
            //  props.loadTableData();
            props.setReload(!props.reload);

            props.HidePenFollowup();
        }
        setLoading(false);
    };


    const onHide = () => {
        setOpenMailBody({ contact_Person_EmailID: "", open: false });
        setMailHistory({ followup_ID: 0, open: false })
    }

    useEffect(() => {
        reset(props.singleData);
    }, [props.singleData])

    function onSubmit(data: any) {
        saveToDB(data);
    }


    const getMailFollowupHistory = async (data: any) => {
        setHistoryData({ tableData: historyData.tableData, loading: true });

        const response = await Fetch("InActivePrimeVendor/getFollowupMailHistory", "GET", null, `followup_ID=${data.followup_ID}`, props.toast);
        if (response) {
            const data: Array<any> = await response.json();
            setHistoryData({ tableData: data, loading: false });
        } else setHistoryData({ tableData: historyData.tableData, loading: false });

    }


    const sendMail = (rowData: any) => {
        // Prepare the mail body template
        const mailTemplate = `
            Dear ${rowData.contact_Person_Name},<br/><br/>
            You are inactive in POC. Please follow up at your earliest convenience.<br/><br/>
            Regards,<br/>
            
        `;
        setMailBody(mailTemplate);
        setMailTo(rowData.contact_Person_EmailID);
        setOpenMailBody({ contact_Person_EmailID: rowData.contact_Person_EmailID, open: true });
    };

    const mailButton = (rowData: any) => {
        return (
            <div className="actions">
                {/* <Button icon="pi pi-envelope" className="p-button-rounded p-button-text ml-2" onClick={() => sendMail(rowData)} tooltip="Send Mail" /> */}
                {/* <Button icon="pi pi-eye" className="p-button-rounded p-button-text" onClick={() => { setMailHistory({ followup_ID: rowData.followup_ID, open: true }); getMailFollowupHistory(rowData); }} tooltip="View documents" /> */}

            </div>
        );
    };

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("InActivePrimeVendor/getfollowupdata", "GET", null, `followup_ID=${props.singleData.followup_ID}`, props.toast);
        if (response) {
            const data: Array<any> = await response.json();
            setTableData({ tableData: data, loading: false });
            if (data && data.length > 0) {
                const dateValue = data[0].next_Followup_Date ? new Date(data[0].next_Followup_Date) : null;
                setValue("next_Followup_Date", dateValue);
                setValue("comment", data[0].comment); // if 'comment' is part of the response

            }
        }
    }

    useEffect(() => {
        if (props.open) {
            loadTableData();
        }
    }, [props.open]);



    const onSubmitMailForm = async (data: any) => {
        setLoading(true);
        const emailPayload = {
            followup_ID: tableData.tableData[0].followup_ID,
            contact_Person_ID: tableData.tableData[0].contact_Person_ID,

            //subject: "Follow-up on Inactive POC",
            contact_Person_EmailID: openMailBody.contact_Person_EmailID,
            emailBody: mailBody
        };
        const response = await Fetch("InActivePrimeVendor/sendFollowupMail", "POST", emailPayload, null, props.toast);
        if (response) {
            props.toast.current.show({ severity: "success", detail: "Email Sent Successfully!", life: 3000 });
        }
        setLoading(false);
        onHide();
    };
    const pDate1 = (rowData: any) => {
        let date;
        if (rowData.createdon) date = format(new Date(rowData.createdon), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };


    return (
        <>
            <Dialog header="Follow-Up Details" visible={props.open} style={{ width: '50vw' }} onHide={props.HidePenFollowup}>
                <DataTable
                    style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                    ref={dt}
                    size="small"
                    stripedRows
                    scrollable
                    scrollHeight="40vh"
                    value={tableData.tableData}
                    resizableColumns
                    showGridlines
                    columnResizeMode="expand"
                    emptyMessage="No Requirements found."
                    loading={tableData.loading}
                >
                    <Column field="contact_Person_Name" header="Contact Person" />
                    <Column field="vendor_Company_Name" header="Vendor Company" />
                    {/* <Column header="Send Mail" body={mailButton} /> */}
                </DataTable>

                <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid gap-3">

                    {/* PHONE FOLLOW-UP SECTION */}
                    <div className="col-12 border-round border-1 surface-border p-3">
                        <h5 className="mt-0 mb-3"></h5>
                        <div className="grid">
                            <div className="col-12 md:col-6">
                                <JVCheckbox column={1} control={control} name="isFollowupOnPhone" label="Follow-Up On Phone" />
                            </div>
                            {isFollowupOnPhone && (
                                <>
                                    <div className="col-12 md:col-6">
                                        <JVRadioBtn
                                            column={3}
                                            label="Responded?"
                                            data={[{ "label": "Yes", "value": "Yes" }, { "label": "No", "value": "No" }]}
                                            control={control}
                                            name="isFollowUpCallRespond"
                                        />
                                    </div>
                                    {isFollowUpCallRespond === "Yes" && (
                                        <div className="col-12">
                                            <JVInput
                                                column={2}
                                                label="Remarks"
                                                control={control}
                                                name="followUpCallRemark"
                                            />
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                    </div>

                    {/* MAIL FOLLOW-UP SECTION */}
                    <div className="col-12 border-round border-1 surface-border p-3">
                        <h5 className="mt-0 mb-3"></h5>
                        <div className="grid">
                            <div className="col-12 md:col-6">
                                <JVCheckbox disabled column={1} control={control} name="isFollowupMail" label="Follow-Up On Mail" />
                            </div>
                            {isFollowupMail && (
                                <>
                                    <div className="col-12 md:col-6">
                                        <JVRadioBtn
                                            column={3}
                                            label="Responded?"
                                            data={[{ "label": "Yes", "value": "Yes" }, { "label": "No", "value": "No" }]}
                                            control={control}
                                            name="isFollowUpMailRespond"
                                        />
                                    </div>
                                    {isFollowUpMailRespond === "Yes" && (
                                        <div className="col-12">
                                            <JVInput
                                                column={2}
                                                label="Remarks"
                                                control={control}
                                                name="followUpMailRemark"
                                            />
                                        </div>
                                    )}
                                </>
                            )}
                        </div>
                    </div>

                    {/* COMMON FIELDS */}
                    <div className="col-12 grid ml-1">
                        <JVDate column={2} label="Next Follow-Up Date" control={control} name="next_Followup_Date" />
                    </div>
                    <div className="col-12 grid">
                        <div className="col-12 md:col-12">
                        </div>
                        <div className="col-12 md:col-12">
                            <div className="col-12 md:col-12">
                                <div className="field">
                                    <label htmlFor="comment">Comment</label>
                                    <Controller
                                        name="comment"
                                        control={control}
                                        render={({ field }) => (
                                            <InputTextarea
                                                id="comment"
                                                {...field}
                                                rows={3}
                                                placeholder=""
                                            />
                                        )}
                                    />
                                </div>
                            </div>
                            {/* <JVInput column={2} label="Comment" control={control} name="comment" /> */}
                        </div>
                    </div>


                    {/* BUTTONS */}
                    <div className="col-12 flex justify-content-end gap-2 mt-3">
                        <Button label="SAVE" type="submit" className="p-button-sm" loading={loading} />
                        <Button label="CLOSE" type="button" className="p-button-outlined p-button-sm" onClick={props.HidePenFollowup} />
                    </div>
                </form>
            </Dialog>


            <Dialog header="" visible={openMailBody.open} style={{ width: '50vw', height: "200" }} onHide={onHide}>
                <form onSubmit={handleSubmit(onSubmitMailForm)} className="p-fluid formgrid grid flex">
                    <div style={{ margin: '10px 0', width: '100%' }}></div>
                    <JVSunEditor value={mailBody} handleChange={setMailBody} />

                    <div className="col-12 md:col-12 flex justify-content-between">
                        <Button className="field col-12 md:col-4 h-2rem" style={{ width: "49%" }} label="SEND" type="submit" loading={loading}></Button>
                        <Button className="field col-12 md:col-4 p-button-outlined h-2rem" style={{ width: "49%" }} label="CANCEL" onClick={onHide} type="button"></Button>
                    </div>
                </form>
            </Dialog>

            <Dialog visible={mailHistory.open} style={{ width: '40vw' }} header="History of Follow-Up Mail" modal className="p-fluid" onHide={onHide} >
                <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                    size="small" stripedRows scrollable scrollHeight="65vh"
                    emptyMessage="No requirement found."
                    value={historyData.tableData}
                // loading={historyRepostData.loading}
                >
                    <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                    {/* <Column field="req_ID" header="Req.ID" sortable body={req_ID} /> */}
                    <Column field="mail_Content_Comment" sortable header="Content" />
                    <Column field="createdon" sortable header="Mail Sent At" body={pDate1} />
                </DataTable>
            </Dialog>
        </>
    );
};